import { render, staticRenderFns } from "./LinkPreviewComponent.vue?vue&type=template&id=86e7b2c6&"
import script from "./LinkPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./LinkPreviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports